"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_ITEM_HOLD_REASON = void 0;
exports.ORDER_ITEM_HOLD_REASON = {
    ARTWORK_ABSENT: 'ARTWORK_ABSENT',
    PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
    PRODUCT_PRICE_NOT_FOUND: 'PRODUCT_PRICE_NOT_FOUND',
    PENDING_CS_APPROVE: 'PENDING_CS_APPROVE'
};
//# sourceMappingURL=orderItemHoldReason.js.map